import React from "react";

const IMG = {
  sandhill:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/jurbe938_2270%20Sand%20Hill%20012.jpg",
  wpNew:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/lh4sm62q_William%20Poole.JPG",
  coastal:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/8m6ayczk_Coastal%20living.JPG",
  beach:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/9slxesra_New%20beach%20House.JPG",
  second:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/eg3kiajo_2nd%20Home.JPG",
  victorian:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/8cpnuzkj_Victorian.JPG",
  cool: "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/4gaipgec_Just%20cool%20house.JPG",
  poole:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/yen6xaby_William%20Poole%20Finished.JPG",
  simple1:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/i4yrkybb_Simple%20design.JPG",
  simple2:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/hphhj2iu_Simple%20design%202.JPG",
  beachHouse:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/wkymjz8i_Beach%20House.JPG",
  historic:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/33zjq2mj_Historic%20rehab.JPG",
  mason:
    "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/he8do7ig_243%20Mason.png",
};

const CATEGORIES = {
  custom: "Custom Home",
  coastal: "Coastal",
  historic: "Historic Rehab",
  farmhouse: "Farmhouse",
  victorian: "Victorian",
};

const PROJECTS = [
  {
    title: "Coastal Living",
    meta: "Main House & Guest Cottage",
    category: CATEGORIES.coastal,
    img: IMG.coastal,
    span: "col-span-12 lg:col-span-8",
    aspect: "aspect-[16/10]",
    testid: "project-coastal-living",
  },
  {
    title: "Sand Hill Estate",
    meta: "Victorian with Turret & Wraparound Porch",
    category: CATEGORIES.victorian,
    img: IMG.sandhill,
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    aspect: "aspect-[4/5]",
    testid: "project-sand-hill",
  },
  {
    title: "Beach House on the Bay",
    meta: "Three-Story with Roof Deck",
    category: CATEGORIES.coastal,
    img: IMG.beachHouse,
    span: "col-span-12 lg:col-span-6",
    aspect: "aspect-[4/3]",
    testid: "project-beach-house",
  },
  {
    title: "Victorian in the Pines",
    meta: "Wraparound Porch & Turret",
    category: CATEGORIES.custom,
    img: IMG.victorian,
    span: "col-span-12 lg:col-span-6",
    aspect: "aspect-[4/3]",
    testid: "project-victorian",
  },
  {
    title: "The William Poole",
    meta: "Cape Cod with Copper Cupola",
    category: CATEGORIES.custom,
    img: IMG.poole,
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    aspect: "aspect-[4/3]",
    testid: "project-william-poole",
  },
  {
    title: "Pine Grove Cape",
    meta: "William Poole Design · Woodland Site",
    category: CATEGORIES.custom,
    img: IMG.wpNew,
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    aspect: "aspect-[4/3]",
    testid: "project-pine-grove",
  },
  {
    title: "The Second Home",
    meta: "Stone & Siding Craftsman",
    category: CATEGORIES.custom,
    img: IMG.second,
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    aspect: "aspect-[4/3]",
    testid: "project-second-home",
  },
  {
    title: "New Beach House",
    meta: "Cape Cod with Dormers",
    category: CATEGORIES.custom,
    img: IMG.beach,
    span: "col-span-12 md:col-span-6 lg:col-span-6",
    aspect: "aspect-[4/3]",
    testid: "project-new-beach-house",
  },
  {
    title: "Just A Cool House",
    meta: "Farmhouse Revival",
    category: CATEGORIES.farmhouse,
    img: IMG.cool,
    span: "col-span-12 md:col-span-6 lg:col-span-6",
    aspect: "aspect-[4/3]",
    testid: "project-cool-house",
  },
  {
    title: "Simple by Design",
    meta: "Two-Story Farmhouse",
    category: CATEGORIES.farmhouse,
    img: IMG.simple2,
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    aspect: "aspect-[4/3]",
    testid: "project-simple-2",
  },
  {
    title: "Sage & Shutter",
    meta: "Two-Story with Garage",
    category: CATEGORIES.custom,
    img: IMG.simple1,
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    aspect: "aspect-[4/3]",
    testid: "project-simple-1",
  },
  {
    title: "Historic Rehabilitation",
    meta: "Downtown Commercial Restoration",
    category: CATEGORIES.historic,
    img: IMG.historic,
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    aspect: "aspect-[4/3]",
    testid: "project-historic-rehab",
    feature: true,
  },
  {
    title: "The Mason Building",
    meta: "Four-Story Historic Commercial · Iron Balconies",
    category: CATEGORIES.historic,
    img: IMG.mason,
    span: "col-span-12",
    aspect: "aspect-[16/8]",
    testid: "project-243-mason",
    feature: true,
    objectPosition: "center 35%",
    maskBottom: true,
  },
];

// Gradient strong enough at bottom to mask camera date stamps
const MASK_GRADIENT =
  "linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0.95) 6%, rgba(0,0,0,0.55) 22%, rgba(0,0,0,0.1) 55%, rgba(0,0,0,0) 80%)";

export default function FeaturedWork() {
  return (
    <section
      id="work"
      data-testid="featured-work-section"
      className="relative py-28 md:py-40 bg-[var(--bg-secondary)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="reveal max-w-2xl">
            <div className="flex items-center gap-4 mb-6">
              <span className="hairline w-10" />
              <span className="eyebrow">Selected Work</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl leading-[1.05] tracking-tight">
              Homes built with{" "}
              <em className="text-[var(--accent)]">intent</em>.
            </h2>
          </div>
          <p className="reveal reveal-delay-1 text-[var(--text-secondary)] max-w-sm leading-relaxed">
            From coastal cottages and classical estates to farmhouses,
            Victorians, and historic rehabilitations — every project delivered
            with the same disciplined craft.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {PROJECTS.map((p, i) => (
            <figure
              key={p.testid}
              className={`reveal ${p.span} group relative overflow-hidden border border-white/10 ${
                p.feature ? "lg:border-[var(--accent)]/40" : ""
              }`}
              style={{ transitionDelay: `${Math.min(i, 6) * 60}ms` }}
              data-testid={p.testid}
            >
              <div className={`zoom-img ${p.aspect} w-full`}>
                <img
                  src={p.img}
                  alt={p.title}
                  className="w-full h-full object-cover"
                  style={p.objectPosition ? { objectPosition: p.objectPosition } : undefined}
                  loading="lazy"
                />
              </div>
              {/* Strong bottom mask to hide original date stamps + improve caption legibility */}
              <div
                className="absolute inset-0"
                style={{
                  background: p.maskBottom
                    ? "linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 14%, rgba(0,0,0,0.55) 28%, rgba(0,0,0,0.1) 60%, rgba(0,0,0,0) 85%)"
                    : MASK_GRADIENT,
                }}
              />

              {/* Category badge */}
              <div className="absolute top-5 left-5">
                <span className="inline-flex items-center gap-2 px-3 py-1.5 border border-white/30 backdrop-blur-sm bg-black/40 text-[10px] uppercase tracking-[0.25em] text-white font-body">
                  {p.category}
                </span>
              </div>

              <figcaption className="absolute bottom-0 left-0 right-0 p-6 md:p-8 flex items-end justify-between">
                <div>
                  <div className="font-body text-[10px] uppercase tracking-[0.3em] text-[var(--accent)] mb-2">
                    {p.meta}
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl text-white leading-tight">
                    {p.title}
                  </h3>
                </div>
                <div className="hidden md:flex h-10 w-10 items-center justify-center border border-white/30 text-white group-hover:border-[var(--accent)] group-hover:text-[var(--accent)] transition-colors duration-500 shrink-0">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.4"
                  >
                    <path d="M7 17L17 7M7 7h10v10" />
                  </svg>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* Stats row under gallery */}
        <div
          className="reveal mt-20 pt-12 border-t border-white/10 grid grid-cols-2 md:grid-cols-4 gap-6"
          data-testid="work-stats"
        >
          <Stat value="14+" label="Projects Delivered" />
          <Stat value="6" label="Project Categories" />
          <Stat value="100%" label="On-Time Handoff" />
          <Stat value="Coast → Country" label="Geographic Range" />
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="font-display text-3xl md:text-5xl text-[var(--accent)] leading-none mb-3">
        {value}
      </div>
      <div className="font-body text-[10px] uppercase tracking-[0.3em] text-[var(--text-secondary)]">
        {label}
      </div>
    </div>
  );
}
